import WidgetBase from "../widget.base";
import Glide from '@glidejs/glide'

export default class GlideCarousel extends WidgetBase {
    static selector = '[data-usc-glide]';


    constructor(el) {
        super(el);

        this.init(this.el.classList[0])
    }

    init(className) {
        let cards = this.el.querySelectorAll(".glide__slide");
        let cardsCount = Array.from(cards).length;

        let slider = new Glide(`.${className}__glide`,
            {
                type: 'slider',
                focusAt: 0,
                bound: true,
                rewind: false,
                perView: cardsCount < 3 ? cardsCount : 3,
                slideWidth: 446,
                wrapperWidth: 446,
                gap: 21,
                breakpoints: {
                    660: {
                        perView: 1,
                    },
                    1388: {
                        perView: cardsCount < 2 ? 1 : 2,
                    }
                }
            })
            .mount();

        slider.on('resize', () => {
            slider.go('=0');
        });
    }
}
